import posthog from 'posthog-js';

export function initAnalytics() {
  posthog.init('phc_vtuESzBPg8Qp9hk96tLAYtCQHZ4Z8RnRGMgUeVRTwL5H', {
    api_host: 'https://eu.i.posthog.com',
    defaults: '2026-01-30',
    capture_pageview: false,
    persistence: 'localStorage+cookie',
    session_recording: {
      maskAllInputs: true,       // mask typed text for privacy
      maskTextSelector: '[data-ph-mask]', // explicit mask selector
    },
    enable_recording_console_log: false,
  });
}

/** Identify a logged-in user so events are tied to their World ID hash */
export function identifyUser(nullifierHash: string, nickname?: string) {
  posthog.identify(nullifierHash, {
    nickname,
    app: 'joystance',
  });
}

/** Reset on logout */
export function resetAnalytics() {
  posthog.reset();
}

/** Track a tab/screen view */
export function trackScreen(name: string, props?: Record<string, unknown>) {
  posthog.capture('$pageview', { $current_url: `/${name}`, screen: name, ...props });
}

/** Track a named event */
export function track(event: string, props?: Record<string, unknown>) {
  posthog.capture(event, props);
}

export default posthog;
